<template>
  <div>
<div class="relative mb-2">
  <div class="overflow-hidden h-48">
    <div class="flex transition-transform duration-300 ease-in-out" :style="{ transform: `translateX(-${currentSlide * 100}%)` }">
      <template v-if="product?.photos && product.photos.length > 0">
        <img v-for="(photo, index) in product.photos" 
             :key="index"
             :src="`/storage/${photo.photo}`"
             :alt="`${product.name} - Image ${index + 1}`"
             class="w-full h-48 object-cover flex-shrink-0" />
      </template>
      <img v-else
           src="https://coffective.com/wp-content/uploads/2018/06/default-featured-image.png.jpg"
           :alt="product.name"
           class="w-full h-48 object-cover flex-shrink-0" />
    </div>
  </div>
  
  <button v-if="product?.photos?.length > 1" 
          @click="prevSlide"
          class="absolute left-0 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 text-white p-2 rounded-r">
    &#8249;
  </button>
  
  <button v-if="product?.photos?.length > 1"
          @click="nextSlide"
          class="absolute right-0 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 text-white p-2 rounded-l">
    &#8250;
  </button>
  
  <div v-if="product?.photos?.length > 1" class="absolute bottom-2 left-1/2 transform -translate-x-1/2 flex space-x-2">
    <button v-for="(_, index) in product.photos"
            :key="index"
            @click="currentSlide = index"
            class="w-2 h-2 rounded-full"
            :class="currentSlide === index ? 'bg-white' : 'bg-white/50'">
    </button>
  </div>
  <!-- Indicador de existencias -->
  <div class="absolute top-0 right-0 m-2 px-2 py-1 rounded text-sm font-bold"
       :class="{
         'bg-red-500 text-white': product?.inventory[0].quantity === 0,
         'bg-yellow-500 text-black': product?.inventory[0].quantity > 0 && product?.inventory[0].quantity <= 10,
         'bg-blue-800 text-white': product?.inventory[0].quantity > 10
       }">
    {{ stockStatus }}
  </div>
</div>
    <h3 class="mb-2 text-lg font-bold">{{ product?.name }}</h3>
    <div class="flex flex-col items-center justify-between sm:flex-row">
      <div>
        <span class="text-gray-600 text-sm">CÓDIGO:</span><br />
        <span class="text-black text-gray-600 font-bold">{{ product?.code }}</span>
      </div>

      <div id="show-content" class="mt-2 sm:mt-0">
        <span class="text-gray-600 text-sm">REF:</span><br />
        <span class="text-lg font-bold">{{ auth ? product.prices[0]['price'].toFixed(2) : '?' }}</span>
      </div>
    </div>

    <div class="flex flex-col items-center sm:flex-row">
      <button @click="addCart" 
              :disabled="product?.inventory[0].quantity === 0"
              class="px-4 py-2 text-white font-bold rounded sm:rounded-l"
              :class="product?.inventory[0].quantity === 0 ? 'bg-gray-400 cursor-not-allowed' : 'bg-green-500 hover:bg-green-700'">
        {{ product?.inventory[0].quantity === 0 ? 'Sin Stock' : 'Añadir' }}
      </button>
      <div class="flex mt-2 border border-gray-300 rounded sm:ml-2 sm:mt-0 sm:rounded-r">
        <button class="px-3 py-2 hover:bg-gray-200" 
                @click="decreaseQuantity"
                :disabled="product?.inventory[0].quantity === 0">-</button>
        <input v-model="quantity" 
               class="w-10 text-center border-l border-r border-gray-300"
               :disabled="product?.inventory[0].quantity === 0" />
        <button class="px-3 py-2 hover:bg-gray-200" 
                @click="increaseQuantity"
                :disabled="product?.inventory[0].quantity === 0">+</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    product: Object,
    auth: Object,
  },
  data() {
    return {
      quantity: 0,
      form: this.$inertia.form({
        product_id: this.product.id,
        quantity: 0,
        price: this.product.prices[0]['price'],
      }),
      currentSlide: 0
    }
  },
  computed: {
    stockStatus() {
      if (this.product?.inventory[0].quantity === 0) return 'Sin Stock';
      if (this.product?.inventory[0].quantity <= 10) return 'Pocas Unidades';
      return 'Hay existencia';
    }
  },
  methods: {
    nextSlide() {
      if (this.currentSlide < this.product.photos.length - 1) {
        this.currentSlide++
      }
    },
    prevSlide() {
      if (this.currentSlide > 0) {
        this.currentSlide--
      }
    },
    increaseQuantity() {
      if (this.quantity < this.product?.inventory[0].quantity) {
        this.quantity++
      }
    },
    decreaseQuantity() {
      if (this.quantity > 1) {
        this.quantity--
      }
    },
    addCart() {
      if (this.product?.inventory[0].quantity === 0) return;
      
      this.form.quantity = this.quantity

      this.form.post('/web/cart')
      this.form.quantity = 0;
      this.quantity = 0;
    },
  },
}
</script>
